<template>
  <div v-if="category">
    <h1>Category</h1>
    <h2>{{ category.shortname }}</h2>
    <v-btn :to="{ name: 'quoteCategories' }">
      <v-icon>chevron_left</v-icon>Categories
    </v-btn>
    <v-btn v-if="!quoteScripts" @click="initialise()"
      >Intialise quote script</v-btn
    >
    <h3>Questions</h3>
    <v-btn :to="{ name: 'questionAdd', query: { categoryid: category.id } }">
      <v-icon>add</v-icon>Question
    </v-btn>
    <v-data-table
      hide-actions
      :headers="headersQuestions"
      :items="computedQuestions"
      class="elevation-1"
      v-if="computedQuestions"
    >
      <template v-slot:items="props">
        <tr :class="props.item.locked ? 'questionLineThrough' : ''">
          <td>
            <v-btn
              small
              :to="{
                name: 'question',
                params: { id: props.item.id }
              }"
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>{{ props.item.body }}</td>
          <td>
            <span v-if="props.item.questionType">{{
              props.item.questionType.name
            }}</span>
          </td>
          <td>
            <span v-if="!props.item.defaultOption">{{
              props.item.defaultvalue
            }}</span>
            <span v-if="props.item.defaultOption">{{
              props.item.defaultOption.value
            }}</span>
          </td>
          <td>
            <v-btn @click="moveQuestion(props.item, true)" small>
              <v-icon>arrow_upward</v-icon>
            </v-btn>
            <v-btn @click="moveQuestion(props.item, false)" small>
              <v-icon>arrow_downward</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <h3>Quote Scripts</h3>
    <v-data-table
      hide-actions
      :headers="headersQuoteScripts"
      :items="quoteScripts"
      class="elevation-1"
      v-if="quoteScripts"
    >
      <template v-slot:items="props">
        <tr :class="props.item.locked ? 'questionLineThrough' : ''">
          <td>
            <v-btn
              small
              :to="{
                name: 'quoteScript',
                params: { id: props.item.id }
              }"
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>{{ props.item.created | formatDateTime }}</td>
          <td>{{ props.item.published | formatDateTime }}</td>
          <td>{{ props.item.archived | formatDateTime }}</td>
          <td>
            <v-btn
              @click="cloneQuoteScript(props.item)"
              small
              v-if="props.item.published"
              >Clone</v-btn
            >
            <v-btn
              @click="deleteQuoteScript(props.item)"
              small
              color="error"
              v-if="!props.item.published"
              ><v-icon>delete</v-icon> Delete</v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import { convertListOfObjectsToMap } from "@/util/helpers";
export default {
  name: "Category",
  metaInfo() {
    return {
      title: "Category",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedQuestions() {
      if (!this.questions) {
        return undefined;
      }
      return this.questions.map((q) => {
        const questionType = this.computedQuestionTypes
          ? this.computedQuestionTypes[q.questiontypeid]
          : undefined;
        const defaultOption =
          questionType && questionType.options
            ? questionType.options[q.defaultoptionid]
            : undefined;
        return { ...q, questionType, defaultOption };
      });
    },
    computedQuestionTypes() {
      if (!this.questionTypes) {
        return undefined;
      }
      const questionTypes = this.questionTypes.map((t) => {
        const options = this.options ? this.options[t.id] : undefined;
        return { ...t, options };
      });
      return convertListOfObjectsToMap(questionTypes, "id");
    }
  },
  data() {
    return {
      category: null,
      questions: null,
      quoteScripts: null,
      questionTypes: null,
      options: null,
      headersQuestions: [
        {
          text: "Id",
          sortable: false
        },
        {
          text: "Body",
          sortable: false
        },
        {
          text: "Question type",
          sortable: false
        },
        {
          text: "Default value",
          sortable: false
        },
        {
          text: "Controls",
          sortable: false
        }
      ],
      headersQuoteScripts: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Created",
          value: "created"
        },
        {
          text: "Published",
          value: "published"
        },
        {
          text: "Archived",
          value: "archived"
        },
        {
          text: "Controls",
          sortable: false
        }
      ]
    };
  },
  methods: {
    async fetchCategory() {
      const response = await nbmlaw.get(
        `/cors/admin/file/categories/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.category = response.data;
    },
    async fetchQuestions() {
      const response = await nbmlaw.get(
        `/cors/admin/file/categories/${this.$route.params.id}/questions`
      );
      // console.log(response.data);
      this.questions = response.data;
    },
    async fetchQuoteScripts() {
      const response = await nbmlaw.get(
        `/cors/admin/file/categories/${this.$route.params.id}/quoteScripts`
      );
      // console.log(response.data);
      this.quoteScripts = response.data;
    },
    async fetchQuestionTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/questionTypes`);
      // console.log(response.data);
      this.questionTypes = response.data;
    },
    async fetchOptions() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/questionTypes/options`
      );
      // console.log(response.data);
      this.options = response.data;
    },
    initialise() {},
    async cloneQuoteScript(quoteScript) {
      const response = await nbmlaw.post(
        `/cors/admin/sales/quoteScripts/${quoteScript.id}`,
        null
      );
      // console.log(response.data);
      this.$router.push({
        name: "quoteScript",
        params: { id: response.data }
      });
    },
    async deleteQuoteScript(quoteScript) {
      if (confirm("Are you sure?")) {
        await nbmlaw.delete(`/cors/admin/sales/quoteScripts/${quoteScript.id}`);
        // console.log(response.data);
        this.update();
      }
    },
    async moveQuestion(question, up) {
      await nbmlaw.put(
        `/cors/admin/file/categories/${this.$route.params.id}/questions/${question.id}/move`,
        null,
        { params: { up } }
      );
      // console.log(response.data);
      this.update();
    },
    update() {
      this.fetchCategory();
      this.fetchQuestions();
      this.fetchQuoteScripts();
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.update();
      }
    }
  },
  created() {
    this.fetchQuestionTypes();
    this.fetchOptions();
  }
};
</script>

<style scoped>
.questionLineThrough {
  text-decoration: line-through;
}
</style>